// extracted by mini-css-extract-plugin
export var cta = "banner-module--cta--aaecd";
export var ctaDescription = "banner-module--ctaDescription--d21e3";
export var ctaDetails = "banner-module--ctaDetails--ef551";
export var ctaEdit = "banner-module--ctaEdit--967e9";
export var ctaImage = "banner-module--ctaImage--5add8";
export var ctaLink = "banner-module--ctaLink--a7e0b";
export var ctaTitle = "banner-module--ctaTitle--9a7d7";